<div class="card">
  <div class="card-body">
    <h3 class="text-center mt-1 fw-bold">Restablece tu contraseña</h3>
    <div class="text-center mb-2">Ingresa una nueva contraseña</div>
    <form
      class="row d-flex flex-column align-items-center mt-4 h-100"
      [formGroup]="newPasswordForm"
      (ngSubmit)="submit()"
    >
      <div class="col-8 p-0 my-2">
        <label for="name" class="form-label">Nueva contraseña</label>
        <div class="input-group prefix mb-3">
          <span
            class="
              input-group-icon
              start
              icon-login_password_lock
              text-center text-primary
              mt-3
            "
          >
          </span>
          <span
            (click)="showPassword = !showPassword"
            [ngClass]="{
              'icon-login_password_hidden': !showPassword,
              'icon-login_password_visible': showPassword
            }"
            class="input-group-icon end text-center text-primary mt-3"
          >
          </span>
          <input
            [type]="showPassword ? 'text' : 'password'"
            class="form-control"
            id="name"
            placeholder="Ingrese su contraseña"
            formControlName="password"
          />
          <div *ngIf=" invalidPassword && passwordErrors" class="invalid-message">
            <ng-container *ngIf="passwordErrors.minL">
              La contraseña debe tener mínimo {{passwordErrors.minL.minlength?.requiredLength}}
              caracteres.
              <br>
            </ng-container>
            <ng-container *ngIf="passwordErrors.maxL">
              La contraseña debe tener maximo {{passwordErrors.maxL.maxlength?.requiredLength}}
              caracteres.<br>
            </ng-container>
            <ng-container *ngIf="!passwordErrors.minL && !passwordErrors.maxL && passwordErrors.pattern">
              La contraseña debe tener 2 de las 3 siguientes condiciones:<br>
              • mayúsculas y minúsculas<br>
              • dígitos <br>
              • carácter especial<br>
            </ng-container>
          </div>
        </div>
      </div>
      <div class="col-8 p-0 my-2">
        <label for="lastnames" class="form-label"
        >Confirmar nueva contraseña</label
        >
        <div class="input-group prefix mb-3">
          <span
            class="
              input-group-icon
              start
              icon-login_password_lock
              text-center text-primary
              mt-3
            "
          >
          </span>
          <span
            (click)="showPassword = !showPassword"
            [ngClass]="{
              'icon-login_password_hidden': !showPassword,
              'icon-login_password_visible': showPassword
            }"
            class="input-group-icon end text-center text-primary mt-3"
          >
          </span>
          <input
            [type]="showPassword ? 'text' : 'password'"
            class="form-control"
            id="lastnames"
            placeholder="Ingrese su contraseña"
            formControlName="secondPassword"
          />
          <div *ngIf=" invalidSecondPassword && confirmPasswordErrors" class="invalid-message">
            <ng-container *ngIf="confirmPasswordErrors.same && password.value">
              Las contraseñas deben ser iguales<br>
            </ng-container>
            <ng-container *ngIf="confirmPasswordErrors.minL">
              La contraseña debe tener mínimo {{confirmPasswordErrors.minL.minlength?.requiredLength}}
              caracteres. <br>
            </ng-container>
            <ng-container *ngIf="confirmPasswordErrors.maxL">
              La contraseña debe tener maximo {{confirmPasswordErrors.maxL.maxlength?.requiredLength}}
              caracteres.<br>
            </ng-container>
            <ng-container
              *ngIf="!confirmPasswordErrors.minL && !confirmPasswordErrors.maxL &&confirmPasswordErrors.pattern">
              La contraseña debe tener 2 de las 3 siguientes condiciones:<br>
              • mayúsculas y minúsculas<br>
              • dígitos <br>
              • carácter especial<br>
            </ng-container>
          </div>
        </div>
      </div>
      <div class="col-8 d-flex flex-column p-0 my-4">
        <button
          class="btn btn-primary mb-1"
          type="submit"
          [disabled]="this.newPasswordForm.invalid"
        >
          Reestablecer contraseña
        </button>
      </div>
    </form>
  </div>
</div>
